import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=1b5606e4&scoped=true&"
import script from "./Buttons.vue?vue&type=script&lang=js&"
export * from "./Buttons.vue?vue&type=script&lang=js&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=1b5606e4&prod&lang=scss&scoped=true&"
import style1 from "./Buttons.vue?vue&type=style&index=1&id=1b5606e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5606e4",
  null
  
)

export default component.exports